import { render, staticRenderFns } from "./sposter.vue?vue&type=template&id=ec1ed508&scoped=true"
import script from "./sposter.vue?vue&type=script&lang=js"
export * from "./sposter.vue?vue&type=script&lang=js"
import style0 from "./sposter.vue?vue&type=style&index=0&id=ec1ed508&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec1ed508",
  null
  
)

export default component.exports